import SiteBlogComponent from "../../components/site/home/site-blog.component";
import SiteCustomerSupportComponent from "../../components/site/home/site-customer-support.component";
import SiteSocialNetworkComponent from "../../components/site/home/site-social-network.component";

type Props = {};

const BlogPage = (props: Props) => {
  return (
    <section className="blog">
      <SiteBlogComponent />
      <SiteCustomerSupportComponent />
      <SiteSocialNetworkComponent />
    </section>
  );
};

export default BlogPage;
